/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//
// source: src/types/shapes/**

import type { PlotMedia } from "../shapes/PlotMedia"
import type { PlotPath } from "../shapes/PlotPath"
import type { PlotRect } from "../shapes/PlotRect"
import type { PlotText } from "../shapes/PlotText"

export type PlotShape =
  | PlotMedia
  | PlotPath
  | PlotRect
  | PlotText
